import useCustomEffect from "../../../../hooks/useCustomEffect";
import FieldsStepView from "./FieldsStepView";

function FieldsStep({ controller }) {
  /**
   * UseEffect for initializing
   */
  useCustomEffect(() => {
    addFetchedEntities();
  });

  /**
   * This method will add the fetched fields to the fetched entities
   */
  function addFetchedEntities() {
    controller.setFetchedEntities((prev) => {
      const newFields = [...prev.fields];
      controller.step.fields.forEach((row) => {
        row.forEach((stepField) => {
          if (
            stepField.field &&
            !newFields.find((field) => field.id === stepField.field.id)
          ) {
            newFields.push(stepField.field);
          }
        });
      });

      return {
        ...prev,
        fields: newFields,
      };
    });
  }

  /**
   * This method will handle the field change event
   * @param {object} stepField
   * @param {any} value
   */
  function onFieldChange(stepField, value) {
    controller.setVisitorData({
      ...controller.visitorData,
      [stepField.field
        ? `field_${stepField.field.id}`
        : stepField.default_field]: value,
    });
  }

  return (
    <FieldsStepView controller={controller} onFieldChange={onFieldChange} />
  );
}

export default FieldsStep;
